import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetPayCardsRequestSchema,
  TGetPayCardsResponseSchema,
} from "./getPayCards.schema";

export const getPayCards = (axios: IAxiosInstance) => {
  return async (params: TGetPayCardsRequestSchema) => {
    const { odo_user_id, ...rest } = params;

    const response = await axios.noRetry.get<
      IApiResponse<TGetPayCardsResponseSchema>
    >(`/api/employees/${odo_user_id}/pay-cards`, { params: rest });

    return response.data;
  };
};
